import React, {Component} from 'react';
import { NavLink, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import Search from '../../../Search';
class HeaderSearch extends Component {

    mapRoutes(key) {
        if(key.hidden) {
          return;
        }
        return (<li key={key}><NavLink className="block" key={key} to={key.url}>{key.title}</NavLink></li>)

    }

    render() {

        if ( this.props.location.pathname !== '/berichten' ) {
            if ( this.props.fullSearchData ) {
                return (
                    <div className="menu menu--top-center"><Search placeholder="Zoek naar adres, plaats, postcode 1234AB" displayCross={true} data={this.props.fullSearchData} keys_to_filter={['city','street','zipcode']}/></div>
                )
            }
        }
        return null;

    }
}

function mapStateToProps(state) {
    return {
        user: state.UserReducer,
        clientPath: state.ClientPathReducer.clientPath,
        searchData: state.SearchDataReducer,
        fullSearchData: state.SearchDataReducer.fullSearchData
    }
}

function mapDispatchToProps(dispatch) {
    return {

    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderSearch));



// WEBPACK FOOTER //
// ./src/components/Layout/Header/HeaderSearch/index.js